import moment from 'moment'

/**
 * Returns an array of objects representing the recent months.
 * Each object has a 'label' (e.g., "May 2026") and a 'value' (e.g., "052026").
 * @param {number} count - Number of months to return.
 * @returns {Array<{label: string, value: string}>}
 */
export const getRecentMonths = (count = 12) => {
  const months = []
  const now = moment()
  for (let i = 0; i < count; i++) {
    const date = moment(now).subtract(i, 'months')
    months.push({
      label: date.format('MMMM YYYY'),
      value: date.format('MMYYYY')
    })
  }
  return months
}
